export default __webpack_public_path__ + "static/media/dani_m.6abe00e0.jpg";